import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import { connect } from 'react-redux';

import { configureAxios, e2eTestLogin, isE2ETest } from '../../Auth';

import './Login.scss';
import { syncCurrentUser } from '../../actions/userActions';

class Login extends Component {
  static propTypes = {
    completeLogin: PropTypes.func.isRequired
  };

  state = {
    email: '',
    password: '',
    isLoggingIn: false
  };

  login = e => {
    e.preventDefault();
    this.setState({ isLoggingIn: true });

    if (isE2ETest) {
      e2eTestLogin({ email: this.state.email, password: this.state.password })
        .then(async () => {
          const currentUser = await this.props.syncCurrentUser(this.state.email);
          if (!currentUser) return;
          this.props.completeLogin();
        })
        .catch(err => {
          cogoToast.error(err.message);
        })
        .finally(() => {
          this.setState({ isLoggingIn: false });
        });
      return;
    }

    Auth.signIn({
      username: this.state.email,
      password: this.state.password
    })
      .then(async res => {
        configureAxios(res);
        const currentUser = await this.props.syncCurrentUser(this.state.email);
        if (!currentUser) return;
        this.props.completeLogin();
      })
      .catch(err => {
        cogoToast.error(err.message);
      })
      .finally(() => {
        this.setState({ isLoggingIn: false });
      });
  };

  render() {
    const { email, password, isLoggingIn } = this.state;

    const header = window.__IS_OFFICE_DOMAIN__ ? 'ShopMy Office Access' : 'ShopMy Admin Portal';
    const subheader = 'Please log in below';
    return (
      <div className='login-outer-container'>
        <div className='login-card'>
          <h1>{header}</h1>
          <h2>{subheader}</h2>
          <form onSubmit={this.login}>
            <input placeholder='Email' value={email} onChange={({ target }) => this.setState({ email: target.value })} />
            <input placeholder='Password' value={password} type='password' onChange={({ target }) => this.setState({ password: target.value })} />
            <button type='submit' className='submit-btn' disabled={isLoggingIn}>
              {isLoggingIn ? '...' : 'Log In'}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  syncCurrentUser
})(Login);
